import { useEffect, useState } from "react";
import { isUserLoggedIn } from "./actions/auth.actions";
import { HashRouter as Router, Route, Routes } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./store";
import "bootstrap/dist/css/bootstrap.min.css";

// Authentication routes
import SignIn from "./pages/authentication/Signin";
import Signup from "./pages/authentication/Signup";
import ForgotPassword from "./pages/authentication/ForgotPassword";
import Otp from "./pages/authentication/Otp";
import AddNewCompany from "./pages/admin/AddNewCompany";

// Dashboards
// import AdminDashboard from "./pages/AdminDashboard";
import ResourceDashboard from "./pages/ResourceDashboard";

// Admin Components
import SideDrawer from "./components/ui/SideDrawer";

// Admin Routes
import TimeSpent from "./pages/admin/TimeSpent";
import Performance from "./pages/admin/Performance";
import ShowResources from "./pages/admin/ShowResources";
import AddMatter from "./pages/admin/AddMatter";
import EditMatter from "./pages/admin/EditMatter";
import ShowMatters from "./pages/admin/ShowMatter";
import ShowClient from "./pages/admin/ShowClient";
import WriteOff from "./pages/admin/WriteOff";
import Invoice from "./pages/admin/Invoice";
import Leave from "./pages/admin/Leave";
import AddEvents from "./pages/admin/AddEvents";
import TimespentTracker from "./pages/admin/TimespentTracker";
import TimeSpentBin from "./pages/admin/TimeSpentBin";
import FinanceReport from "./pages/admin/FinanceReport";
import Ope from "./pages/admin/Ope";
import Opex from "./pages/admin/Opex";
import Financial from "./pages/admin/Financial";

// Resource Routes
import AddTime from "./pages/resource/AddTime";
import ExportExcelResource from "./pages/resource/ExportExcel";
import Calendar from "./pages/resource/Calendar";
import ResourceOPE from "./pages/resource/ResourceOPE";
import ResourceLeave from "./pages/resource/ResourceLeave";
import TimeTracker from "./pages/resource/Timetracker";
import "./index.css";

//Other Routes
import Protected from "./components/Protected";
import NotFound from "./components/NotFound";
import AdminConsent from "./pages/authentication/AdminConsent";
import SuperAdminPortal from "./pages/super-admin/SuperAdminPortal";
import Popup from "./pages/outlook/Popup";
import AiAgentChat from "./components/ui/AiAgentChat";

const App = () => {
  const [sessionReady, setSessionReady] = useState(false);
  const [sessionError, setSessionError] = useState(null);
  const restoreSession = () => {
    setSessionError(null);
    setSessionReady(false);
    store.dispatch(isUserLoggedIn())
      .then(() => setSessionReady(true))
      .catch(error => {
        if (error.response?.status === 401) setSessionReady(true);
        else setSessionError(error.response?.status === 404
          ? "The sign-in service needs updating. Please update the API server and retry."
          : "We couldn’t connect to the sign-in service. Please retry or go to login.");
      });
  };
  useEffect(() => {
    if (localStorage.getItem("API_BASE_URL") || process.env.REACT_APP_API_BASE_URL
      || ["localhost", "127.0.0.1"].includes(window.location.hostname)) restoreSession();
    else setSessionReady(true);
  }, []);
  const goToLogin = () => {
    ["authToken", "token", "user"].forEach(key => localStorage.removeItem(key));
    store.dispatch({ type: "LOGOUT_SUCCESS" });
    window.location.hash = "#/";
    setSessionError(null);
    setSessionReady(true);
  };
  if (sessionError) return (
    <div role="alert" style={{ padding: "24px" }}>
      <p>{sessionError}</p>
      <button onClick={restoreSession}>Retry</button>{" "}
      <button onClick={goToLogin}>Go to login</button>
    </div>
  );
  if (!sessionReady) return <div>Checking your session…</div>;
  return (
    <Provider store={store}>
      <Router>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<SignIn />} />
          <Route path="/admin/signup" element={<Signup />} />
          <Route path="/otp" element={<Otp />} />
          <Route path="/forgotPassword" element={<ForgotPassword />} />
          <Route path="/adminconsent" element={<AdminConsent />} />
          <Route path="/outlook/popup" element={<Popup /> } />

          {/* Super admin portal  */}
          <Route path="/superadmin" element={<SuperAdminPortal />} />

          <Route
            path="/admin/addnewcompany"
            element={
              <Protected allowedRoles={["admin"]}>
                <SideDrawer>
                  <AddNewCompany />
                </SideDrawer>
              </Protected>
            }
          />
          <Route
            path="/admin/events"
            element={
              <Protected allowedRoles={["admin"]}>
                <SideDrawer>
                  <div style={{ padding: "20px" }}>
                    <AddEvents />
                  </div>
                </SideDrawer>
              </Protected>
            }
          />
          <Route
            path="/admin/reports/timespent"
            element={
              <Protected allowedRoles={["admin"]}>
                <SideDrawer>
                  <TimeSpent />
                </SideDrawer>
              </Protected>
            }
          />
          <Route
            path="/admin/reports/performance"
            element={
              <Protected allowedRoles={["admin"]}>
                <SideDrawer>
                  <Performance />
                </SideDrawer>
              </Protected>
            }
          />
          <Route
            path="/adminDashboard"
            element={
              <Protected allowedRoles={["admin"]}>
                <SideDrawer>
                  <Financial />
                </SideDrawer>
              </Protected>
            }
          />
          <Route
            path="/admin/reports/invoice"
            element={
              <Protected allowedRoles={["admin"]}>
                <SideDrawer>
                  <Invoice />
                </SideDrawer>
              </Protected>
            }
          />
          <Route
            path="/admin/reports/writeOff"
            element={
              <Protected allowedRoles={["admin"]}>
                <SideDrawer>
                  <WriteOff />
                </SideDrawer>
              </Protected>
            }
          />
          <Route
            path="/admin/reports/tstracker"
            element={
              <Protected allowedRoles={["admin"]}>
                <SideDrawer>
                  <TimespentTracker />
                </SideDrawer>
              </Protected>
            }
          />
          <Route
            path="/admin/reports/bin"
            element={
              <Protected allowedRoles={["admin"]}>
                <SideDrawer>
                  <TimeSpentBin />
                </SideDrawer>
              </Protected>
            }
          />
          <Route
            path="/admin/reports/finance"
            element={
              <Protected allowedRoles={["admin"]}>
                <SideDrawer>
                  <FinanceReport />
                </SideDrawer>
              </Protected>
            }
          />
          <Route
            path="/admin/reports/leave"
            element={
              <Protected allowedRoles={["admin"]}>
                <SideDrawer>
                  <Leave />
                </SideDrawer>
              </Protected>
            }
          />
          <Route
            path="/admin/reports/opex"
            element={
              <Protected allowedRoles={["admin"]}>
                <SideDrawer>
                  <Opex />
                </SideDrawer>
              </Protected>
            }
          />
          <Route
            path="/admin/reports/ope"
            element={
              <Protected allowedRoles={["admin"]}>
                <SideDrawer>
                  <Ope />
                </SideDrawer>
              </Protected>
            }
          />
          <Route
            path="/admin/allresources"
            element={
              <Protected allowedRoles={["admin"]}>
                <SideDrawer>
                  <ShowResources />
                </SideDrawer>
              </Protected>
            }
          />
          <Route
            path="/admin/addmatter"
            element={
              <Protected allowedRoles={["admin"]}>
                <SideDrawer>
                  <AddMatter />
                </SideDrawer>
              </Protected>
            }
          />
          <Route
            path="/admin/editmatter"
            element={
              <Protected allowedRoles={["admin"]}>
                <SideDrawer>
                  <EditMatter />
                </SideDrawer>
              </Protected>
            }
          />
          <Route
            path="/admin/showmatters"
            element={
              <Protected allowedRoles={["admin"]}>
                <SideDrawer>
                  <ShowMatters />
                </SideDrawer>
              </Protected>
            }
          />
          <Route
            path="/admin/showclient"
            element={
              <Protected allowedRoles={["admin"]}>
                <SideDrawer>
                  <ShowClient />
                </SideDrawer>
              </Protected>
            }
          />
          <Route
            path="/admin/showclient"
            element={
              <Protected allowedRoles={["admin"]}>
                <SideDrawer>
                  <ShowClient />
                </SideDrawer>
              </Protected>
            }
          />

          {/* Resource Routes */}
          <Route
            path="/resourceDashboard"
            element={
              <Protected allowedRoles={["employee"]}>
                <ResourceDashboard />
              </Protected>
            }
          />
          <Route
            path="/resource/addtime"
            element={
              <Protected allowedRoles={["employee"]}>
                <AddTime />
              </Protected>
            }
          />
          <Route
            path="/resource/calendar"
            element={
              <Protected allowedRoles={["employee"]}>
                <Calendar />
              </Protected>
            }
          />

          <Route
            path="/resource/exportexcel"
            element={
              <Protected allowedRoles={["employee"]}>
                <ExportExcelResource />
              </Protected>
            }
          />
          <Route
            path="/resource/ope"
            element={
              <Protected allowedRoles={["employee"]}>
                <ResourceOPE />
              </Protected>
            }
          />
          <Route
            path="/resource/leaves"
            element={
              <Protected allowedRoles={["employee"]}>
                <ResourceLeave />
              </Protected>
            }
          />
          <Route 
            path="/resource/timetracker"
            element={
              <Protected allowedRoles={["employee"]}>
                <TimeTracker />
              </Protected>  
            }
          />

          {/* 404 Not Found Route */}
          <Route path="*" element={<NotFound />} />
        </Routes>
        <AiAgentChat />
      </Router>
    </Provider>
  );
};

export default App;
